/**
 * Bridge Strategy — 事件埋点（懒加载）
 *
 * Landing 页面跳过了 SDK 初始化（_app.tsx isLandingPage），
 * 通过 import() 动态加载 logAdapter。
 * initTracker() 内部有单例保护，不会重复初始化。
 */
import type { LandingBridgeMediator } from '../types';

export function registerTrackStrategy(bridge: LandingBridgeMediator): void {
  bridge.register('track', (event: string, data?: Record<string, any>) => {
    import('@/utils/eventlog/logAdapter')
      .then(({ trackEvent }) => {
        trackEvent(event as any, { ...data, source: 'landing_section' });
      })
      .catch((err) => {
        console.warn('[LandingBridge] track failed:', err.message);
      });
  });
}
